/**
 * Clickable column header for sortable tables.
 * Renders the label + a small chevron that reflects the current sort state.
 * If `sortKey` is null/undefined, the header behaves like a plain label.
 *
 * Pairs with usePaginatedSort:
 *   <SortableHeader label="Nombre" sortKey="name"
 *                   currentKey={sortKey} currentDir={sortDir}
 *                   onSort={toggleSort} />
 */
export default function SortableHeader({
  label, sortKey, currentKey, currentDir, onSort, align = 'left',
}) {
  const isActive = sortKey && currentKey === sortKey;
  const indicator = !sortKey ? '' : isActive ? (currentDir === 'asc' ? '▲' : '▼') : '⇅';
  const clickable = !!sortKey;
  return (
    <span
      onClick={clickable ? () => onSort(sortKey) : undefined}
      style={{
        cursor: clickable ? 'pointer' : 'default',
        userSelect: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start',
        gap: 4,
        width: '100%',
        textAlign: align,
      }}
      title={clickable ? `Ordenar por ${label}` : undefined}
    >
      <span>{label}</span>
      {clickable && (
        <span style={{
          fontSize: 9,
          opacity: isActive ? 1 : 0.35,
          color: isActive ? '#d97706' : '#94a3b8',
        }}>{indicator}</span>
      )}
    </span>
  );
}
